import { bl_del_job_subline_link_RowClass, bl_del_job_subline_link_RowInterface } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class JobSubLineLinkContainerModel extends BaseContainerModel {
  bl_del_job_doc_subline_link: bl_del_job_subline_link_RowInterface = new bl_del_job_subline_link_RowClass();
}